<template>
    <div
        :data-component-name="$options.name"
    >
        <button class="c-dashboard-control -calendar -border-bottom" v-if="!useInput">
            <SvgIcon name="calendar" />
            <q-popup-proxy transition-show="scale" transition-hide="scale" ref="qDateProxy">
                <q-date 
                    minimal
                    v-bind="$attrs"
                    mask="YYYY-MM-DD"
                    @input="dateSet($event)"
                    :first-day-of-week="$generalSettings.settings.firstDayOfWeek"
                >
                </q-date>
            </q-popup-proxy>
        </button>
        <q-input
            v-else
            filled
            :value="$attrs.value"
            mask="YYYY-MM-DD"
        >
            <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                    <q-date
                        minimal
                        v-bind="$attrs"
                        mask="YYYY-MM-DD"
                        :first-day-of-week="$generalSettings.settings.firstDayOfWeek"
                        @input="dateSet($event)"
                    >
                    <div class="row items-center justify-end">
                        <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                    </q-date>
                </q-popup-proxy>
                </q-icon>
            </template>
        </q-input>
    </div>
</template>

<script>
    import QDate from 'quasar'
    // import moment from 'moment';

    export default {
        name: "RangePicker",
        extends: QDate,
        props: {
            useInput: {
                type: Boolean,
                default: false
            },
            outlined: {
                type: Boolean,
                default: false
            },
            dense: {
                type: Boolean,
                default: true
            },
            filled: {
                type: Boolean,
                default: true
            },
            currentDate: String
        },
        data(){
            return {
            }
        },
        mounted(){
        },
        computed:  {
        },
        methods: {
            updateProxy () {
            },
            save () {
            },
            dateSet(val) {
                this.$emit('set-current-date', val);
                if(!this.$attrs.multiple) this.$refs.qDateProxy.hide();
            }
        }
    }
</script>